import type { NextPage } from 'next'
import { useRouter } from "next/router"

import BlankLayout from './blank'
import DefaultLayout from './eia'


const blankLayoutPages = [
  '/account/sign-in',
  '/account/sign-up',
  '/account/sign-up-soon',
  '/account/sign-up-complete',
  '/account/find-my-password',
  '/auth/niceCallback',
]

const Layout = (): NextPage => {
  const { route } = useRouter()  // pathname, route,
  if (blankLayoutPages.includes(route)) {
    return BlankLayout
  } else {
    return DefaultLayout
  }
}

export default Layout
